import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-047f1a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "howTo" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Die Zahlen vor den Zeilen und über den Spalten definieren die auszufüllenden Blöcke von Kästchen:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Jeder Zahlwert entspricht genau der Länge eines Blockes.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bei mehreren Zahlen entspricht ihre Abfolge der Reihenfolge der Blöcke.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Zwischen zwei Blöcken muss sich mindestens ein leeres Feld befinden.", -1))
const _hoisted_7 = { class: "navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Headline = _resolveComponent("Headline")!
  const _component_BreakLine = _resolveComponent("BreakLine")!
  const _component_game_grid = _resolveComponent("game-grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Headline, {
      title: "Anleitung",
      class: "pt-32"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BreakLine),
      _hoisted_3,
      _createVNode(_component_game_grid, {
        nonogramm: _ctx.tutorial1,
        hideTopBlockNumbers: true,
        class: "tutorialGrid"
      }, null, 8, ["nonogramm"]),
      _hoisted_4,
      _createVNode(_component_game_grid, {
        nonogramm: _ctx.tutorial2,
        hideTopBlockNumbers: true,
        class: "tutorialGrid"
      }, null, 8, ["nonogramm"]),
      _hoisted_5,
      _createVNode(_component_game_grid, {
        nonogramm: _ctx.tutorial3,
        hideTopBlockNumbers: true,
        class: "tutorialGrid"
      }, null, 8, ["nonogramm"]),
      _hoisted_6,
      _createVNode(_component_BreakLine),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
}